export const HELP_FAQ = [
  {
    q: "Do I need to register or sign in?",
    a: "No registration or password. Install from Stripe Marketplace, open InvoiceVault in the Dashboard drawer, and click any link — you're redirected to the web app and signed in automatically.",
  },
  {
    q: "Do I need to sync data first?",
    a: "No — InvoiceVault reads invoices live from Stripe when you search or export on the web app.",
  },
  {
    q: "Can I search or download in the Stripe Dashboard?",
    a: "No — the drawer is only an entry point. Open InvoiceVault in the right-hand drawer and click any link to sign in to the web app. Search, exports, and ZIP downloads happen there. Track jobs in Export History.",
  },
  {
    q: "How is Bulk Export different from other exports?",
    a: "Bulk Export PDFs (Pro) is for very large jobs — filter and export up to hundreds of thousands of invoice PDFs in one background run. Work is split into multiple ZIP volumes; track progress in Export History. Other exports (selected rows, single-page lists) are smaller and meant for quick batches.",
  },
  {
    q: "What is included in Starter?",
    a: "Starter is free. You can browse, download Invoice PDFs, Receipts, Credit Notes, Pay Links, and use Export History. Bulk Export Invoice PDFs requires Pro.",
  },
  {
    q: "How much does Pro cost?",
    a: "Pro is $10 per month. Starter is free. Subscribe from Plans; payment and cancellation run through Stripe.",
  },
  {
    q: "Where are my ZIP files stored?",
    a: "Finished ZIP volumes are stored encrypted in Google Cloud Storage. Download links expire after 15 minutes; files are retained for 15 days.",
  },
  {
    q: "How do I upgrade Starter to Pro?",
    a: "Open Plans from the sidebar, then Subscribe on the Pro card. Stripe Checkout opens in this tab. After payment you return to Plans.",
  },
  {
    q: "How do I cancel Pro?",
    a: "Open Plans while subscribed, then Cancel subscription on the Pro card. Stripe opens so you can stop next month's renewal. This month's plan stays active and cannot be canceled.",
  },
  {
    q: "Do you store my invoice PDFs?",
    a: "No PDF file content in our database — only export job metadata (status, filters, results). PDFs are fetched from Stripe when you export, then packed into ZIP archives stored encrypted in Google Cloud Storage and automatically deleted after 15 days. We do not warehouse your full Stripe dataset.",
  },
  {
    q: "What Stripe permissions does InvoiceVault need?",
    a: "Read access to invoices, receipts, credit notes, and payment links. We do not modify your Stripe charges.",
  },
] as const;
